/* eslint-disable no-constant-condition */
import { stringify } from 'querystring'

import { trackEvent } from '@patrianna/analytics'
import { closeLatestDialog } from '@patrianna/dialog-manager'
import { useMediaQuery } from '@patrianna/shared-hooks'
import type { SocialAuthTypes } from '@patrianna/shared-patrianna-types/store/AuthModule'
import { getAuthFlowLoadingSelector } from '@patrianna/shared-store/auth'
import { nextTick } from '@patrianna/shared-utils'
import { EmailOutline } from '@patrianna-icons/material-icons'
import { usePathname, useRouter } from 'next/navigation'
import { useCallback } from 'react'

import ROUTES from 'config/routes.json'
import Button from 'src/components/Button'
import { useAppSelector } from 'src/store/hooks'

import classes from './styles.module.scss'

type Props = {
  // own props
  title: string
  path?: 'login'
  authType: SocialAuthTypes
  authDialogOptions?: {
    loginWays: 'manual_only' | 'social_only'
  }
  skipTrackEvent?: boolean
}

function EmailAuthButton(props: Props) {
  const isMobile = useMediaQuery('xs')
  const router = useRouter()
  const pathname = usePathname()
  const isLoading = useAppSelector(getAuthFlowLoadingSelector)
  const queryOptions = props.authDialogOptions ? `&${stringify(props.authDialogOptions)}` : ''

  const handleClick = useCallback(() => {
    nextTick().then(() => {
      if (!isMobile || 'LOGIN') {
        closeLatestDialog()
      }

      if (props.authType === 'LOGIN') {
        router.push(ROUTES.LOGIN)
      } else {
        router.push(
          `${pathname}?auth_type=${'REGISTRATION'}_MANUAL${queryOptions}&${window.location.search.substring(
            1,
            window.location.search.length,
          )}`,
        )
      }

      if (!props.skipTrackEvent) {
        trackEvent('register_page_email_button')
      }
    })
  }, [isMobile, props.authType, props.skipTrackEvent, router, pathname, queryOptions])

  return (
    <Button disabled={isLoading} className={classes.root} onClick={handleClick} data-test='register-using-email'>
      <span className={classes.buttonBox}>
        <EmailOutline className={classes.icon} />
        <span className={classes.text}>{props.title}</span>
      </span>
    </Button>
  )
}

export default EmailAuthButton
